/* Stamped reviews carousel helper (AJ 2026-10-21), paired with cq-stamped-carousel.css.
   The CSS turns the carousel into a native swipe row, so Stamped's own slide script (it moves the row with an
   inline "left") no longer applies. This file makes the two arrows scroll the row one card group at a time,
   wrapping at either end like Stamped did, and makes them keyboard buttons with names for screen readers.
   Where the block has auto play on (the homepage), the row advances every few seconds while it is on screen,
   pauses while the pointer or keyboard focus is inside it, stops for good after any arrow press, swipe or
   scroll by the visitor, and never runs for visitors who ask for reduced motion. */
(function () {
  if (window.cqStampedCarousel) return;
  window.cqStampedCarousel = true;

  // Review photos (2026-10-29): Stamped prints <img height="130"> with no width, which the aspect-ratio audit reads as a
  // distorted image while the widget is still hidden. Drop the attribute as the photos arrive; the stylesheet already
  // sizes them with height auto, so nothing visible changes.
  function unsizeReviewPhotos(root) {
    root.querySelectorAll('.stamped-review-image img[height]:not([width])').forEach(function (img) { img.removeAttribute('height'); });
  }
  function watchReviewPhotos() {
    var mount = document.getElementById('stamped-main-widget');
    if (!mount || mount.hasAttribute('data-cq-photo-watch') || !('MutationObserver' in window)) return;
    mount.setAttribute('data-cq-photo-watch', '');
    unsizeReviewPhotos(mount);
    new MutationObserver(function () { unsizeReviewPhotos(mount); }).observe(mount, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchReviewPhotos); else watchReviewPhotos();

  var WIDGET = '[data-widget-type="carousel"]';
  var ARROW = WIDGET + ' .stamped-carousel-buttons > div';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slide(arrow) {
    var widget = arrow.closest(WIDGET);
    var row = widget && widget.querySelector('.stamped-carousel-scroll');
    if (!row) return;
    var card = row.querySelector('.block');
    var cardWidth = card ? card.getBoundingClientRect().width : row.clientWidth;
    var step = cardWidth > 0 ? Math.max(1, Math.floor((row.clientWidth + 2) / cardWidth)) * cardWidth : row.clientWidth;
    var max = row.scrollWidth - row.clientWidth;
    var back = arrow.classList.contains('stamped-carousel-button-left');
    var target;
    if (back) target = row.scrollLeft <= 4 ? max : row.scrollLeft - step;
    else target = row.scrollLeft >= max - 4 ? 0 : row.scrollLeft + step;
    row.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  var autoPlayers = [];

  function stopAutoPlay(widget) {
    autoPlayers.forEach(function (player) {
      if (!widget || player.widget === widget) player.stopped = true;
    });
  }

  function startAutoPlay(widget) {
    if (reduceMotion || widget.getAttribute('data-auto-play') !== 'true' || widget.hasAttribute('data-cq-autoplay')) return;
    widget.setAttribute('data-cq-autoplay', '');
    var speed = parseInt(widget.getAttribute('data-auto-play-speed'), 10);
    var player = { widget: widget, stopped: false, paused: false, visible: false };
    autoPlayers.push(player);
    widget.addEventListener('mouseenter', function () { player.paused = true; });
    widget.addEventListener('mouseleave', function () { player.paused = false; });
    widget.addEventListener('focusin', function () { player.paused = true; });
    widget.addEventListener('focusout', function () { player.paused = false; });
    var row = widget.querySelector('.stamped-carousel-scroll');
    ['touchstart', 'wheel', 'pointerdown'].forEach(function (type) {
      row.addEventListener(type, function () { player.stopped = true; }, { passive: true });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        player.visible = entries[0].isIntersecting;
      }, { threshold: 0.5 }).observe(widget);
    } else {
      player.visible = true;
    }
    var timer = setInterval(function () {
      if (player.stopped) return clearInterval(timer);
      if (player.paused || !player.visible || document.hidden) return;
      var next = widget.querySelector('.stamped-carousel-button-right');
      if (next) slide(next);
    }, speed >= 3000 ? speed : 6000);
  }

  function arrowFrom(event) {
    return event.target && event.target.closest ? event.target.closest(ARROW) : null;
  }

  // Capture phase, so Stamped's inline onclick (which would set an inline "left") never runs.
  document.addEventListener('click', function (event) {
    var arrow = arrowFrom(event);
    if (!arrow) return;
    event.preventDefault();
    event.stopPropagation();
    stopAutoPlay(arrow.closest(WIDGET));
    slide(arrow);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var arrow = arrowFrom(event);
    if (!arrow) return;
    event.preventDefault();
    stopAutoPlay(arrow.closest(WIDGET));
    slide(arrow);
  }, true);

  function addReviewLinks(widget) {
    var section = widget.closest('[data-cq-review-read-more]');
    var label = section && section.getAttribute('data-cq-review-read-more');
    if (!label) return;
    widget.querySelectorAll('.stamped-reviews-product-title').forEach(function (product) {
      var source = product.querySelector('a.stamped-reviews-link');
      if (!source || product.querySelector('.cq-review-more')) return;
      // One link carries both lines (2026-10-29): the product name and the Read more label share Stamped's destination,
      // which includes the selected review ID, so the tap target is the whole two-line footer instead of two 16 px rows.
      var title = document.createElement('span');
      title.className = 'cq-review-product';
      while (source.firstChild) title.appendChild(source.firstChild);
      var more = document.createElement('span');
      more.className = 'cq-review-more';
      more.textContent = label;
      source.appendChild(title);
      source.appendChild(more);
      // The two visible lines supply the link name in reading order, including the translated action.
      source.removeAttribute('aria-label');
    });
  }

  function enhance(widget) {
    var done = true;
    widget.querySelectorAll('.stamped-carousel-buttons > div').forEach(function (arrow) {
      if (arrow.hasAttribute('data-cq-arrow')) return;
      arrow.setAttribute('data-cq-arrow', '');
      arrow.setAttribute('role', 'button');
      arrow.setAttribute('tabindex', '0');
      arrow.setAttribute('aria-label', arrow.classList.contains('stamped-carousel-button-left') ? 'Previous reviews' : 'Next reviews');
    });
    var row = widget.querySelector('.stamped-carousel-scroll');
    if (row && !row.hasAttribute('role')) {
      row.setAttribute('role', 'region');
      row.setAttribute('aria-label', 'Customer reviews');
    }
    if (!widget.querySelector('.stamped-carousel-buttons > div') || !row ||
        !widget.querySelector('.stamped-reviews-product-title a.stamped-reviews-link')) done = false;
    if (done) {
      addReviewLinks(widget);
      startAutoPlay(widget);
    }
    return done;
  }

  function watch() {
    document.querySelectorAll(WIDGET).forEach(function (widget) {
      if (enhance(widget)) return;
      var observer = new MutationObserver(function () {
        if (enhance(widget)) observer.disconnect();
      });
      observer.observe(widget, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
